import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, signal, ViewEncapsulation } from '@angular/core';
import { ApiTypes, SlideDirective, SliderComponent, type SliderOptions } from '@hyundai/ng-common-lib';
import { Store } from '@ngrx/store';
import { VehicleCardComponent } from '../../components/vehicle-card/vehicle-card.component';

@Component({
    selector: 'lib-similar-vehicles',
    standalone: true,
    imports: [VehicleCardComponent, SliderComponent, SlideDirective, NgClass],
    templateUrl: './similar-vehicles.component.html',
    styleUrl: './similar-vehicles.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'lib-similar-vehicles',
    },
})
export class SimilarVehiclesComponent {
    store = inject(Store);

    title = input.required();
    similarVehicles = input.required<ApiTypes.Vehicles>();

    currentSlide = signal(0);

    sliderOptions: SliderOptions = {
        initial: 0,
        renderMode: 'performance',
        slides: {
            perView: 1,
        },
        breakpoints: {
            '(max-width: 1179px)': {
                slides: {
                    perView: 'auto',
                },
            },
        },

        slideChanged: (slider) => {
            this.currentSlide.set(slider.track.details.rel);
        },
    };
}
